module.exports = __webpack_public_path__ + "img/mp.c5eb7f23.svg";